<input
  #stringInput
  type="text"
  [formControl]="durationFormControl"
  (beforeinput)="durationInputTransformFn($event, durationFormControl)"
  (paste)="durationInputPasteFn($event, durationFormControl)"
  [placeholder]="durationFormat"
  [ngStyle]="config?.inputStyles"
  class="string-input"
/>
